<template>
  <div class="centerx">
    <vs-popup class="checkout-popup" title="Checkout info" :active.sync="popupConfig.isOpen">
        <div class="vx-row h-full px-6 checkout-popup-content">
            <div class="vx-col custom-col pr-0 lg:pr-6 pl-0 lg:w-1/2 w-full content-1">
                <div class="vx-row flex align-center">
                    <div>
                        <vs-avatar class="text-4xl font-bold" size="90px" text="abc"/>
                    </div>
                    <div class="ml-4">
                        <div class="font-bold text-2xl" style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;">abc</div>
                        <div>
                            <i class="material-icons text-base">phone</i>
                            0902791501
                        </div>
                        <div class="my-3">
                            <vs-alert class="text-center" active="true" style="width: 80px">Normal</vs-alert>
                        </div>
                    </div>
                </div>
                <vs-divider class="py-3"></vs-divider>
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mb-5">
                        <div class="text-sm">Points</div>
                        <p class="text-xl">0 Pts</p>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mb-5">
                        <div class="text-sm">Visit</div>
                        <p class="text-xl">4 times</p>
                    </div>
                    <div class="vx-col w-full mb-5">
                        <div class="text-sm">Check in</div>
                        <p class="text-xl">09/03/20 13:03</p>
                    </div>
                </div>

                <div class="vx-row justify-center">
                    <vs-button type="border" color="success">Staffs</vs-button>
                    <vs-button type="border" color="warning">Services</vs-button>
                </div>

                <div>
                    <p class="py-5 leading-normal text-xl">Note</p>
                    <vs-textarea v-model="note" height="110"/>
                </div>

                <vs-button type="border" class="float-right mx-0">Save</vs-button>
            </div>

            <!-- <div class="vx-col custom-col lg:mt-0 mt-6 mb-4 border-left-custom border-right-custom px-6 lg:w-1/3 w-full content-2">
                <div>
                    <p class="leading-normal text-xl">Total amount</p>
                    <div class="w-full" v-if="this.current.length >= 1">
                      <span class="text-5xl py-5 display">{{current}}</span>
                    </div>
                    <div v-else>
                      <span class="text-5xl py-5 display"> 0 </span>
                    </div>
                    <div class="vx-row border-top-custom border-bottom-custom py-3 mx-0">
                        <div class="vx-col w-1/3 p-2" v-for="num in 9" :key="num" v-on:click="append(num)">
                            <btn-custom type="border" class="w-full text-5xl p-3 m-0" :value="num">{{num}}</btn-custom>
                        </div>
                        <div class="vx-col w-1/3 p-2">
                            <btn-custom type="border" class="w-full text-5xl p-3 m-0" value="10" @click="dot">.</btn-custom>
                        </div>
                        <div class="vx-col w-1/3 p-2">
                            <btn-custom type="border" class="w-full text-5xl p-3 m-0" value="0" @click="append('0')">0</btn-custom>
                        </div>
                        <div class="vx-col w-1/3 p-2">
                            <btn-custom type="border" class="w-full text-5xl p-3 m-0" v-on:click="deleteNum()">
                                <i class="material-icons">backspace</i>
                            </btn-custom>
                        </div>
                    </div>

                    <div class="mt-3" v-if="current.length >= 1">
                      <span>Pay</span>
                      <span class="float-right">${{reCalculator()}}</span>
                    </div>
                    <div class="mt-3" v-else>
                      <span>Pay</span>
                        <span class="float-right">$0</span>
                    </div>

                    <div v-if="current.length >= 1">
                      <span>Point</span>
                      <span class="float-right">+{{Math.round(reCalculator())}}</span>
                    </div>
                    <div v-else>
                      <span>Point</span>
                      <span class="float-right">+0</span>
                    </div>

                    <div class="vx-row justify-center mt-2">
                        <vs-button type="border" color="danger" @click.stop="closePopup">Close</vs-button>
                        <vs-button type="border">Checkout</vs-button>
                    </div>
                </div>
            </div> -->
            <div class="vx-col custom-col lg:pl-6 px-0 lg:w-1/2 w-full content-3">
              <div class="vx-row">
                  <div class="vx-col lg:w-full w-1/2">
                      <div class="flex justify-between align-center">
                        <div class="leading-normal text-xl">Promotion</div>
                        <vs-button @click="clearPromotion" class="mr-0">Clear</vs-button>
                      </div>
                      <div class="rounded w-full promotion">
                          <vs-list v-for="(item, index) in promotion_list" :key="index">
                              <list-radio-item :item="item" @ChangeStatusRadio="changeStatusRadio">
                              </list-radio-item>
                          </vs-list>
                          <input name="radio" id="temp-radio" type="radio" hidden>
                      </div>
                  </div>
                  <div class="lg:mt-5 vx-col lg:w-full w-1/2">
                      <p class="lg:mb-4 mb-2 leading-normal text-xl">Redemption</p>
                      <div class="rounded w-full redemption">
                          <vs-list v-for="(item, index) in redemtion_list" :key="index">
                              <list-item :item="item"></list-item>
                          </vs-list>
                      </div>
                  </div>
              </div>
            </div>
        </div>
    </vs-popup>
  </div>
</template>

<script>
    import { StringHelper } from '../../models/string_helper'
    import moment from 'moment';
    export default {
        name: "vs-popup-info",
        components: {
            ListItem: () => import("./ListItem.vue"),
            ListRadioItem: () => import("./ListRadioItem.vue"),
        },
        props: {
            popupConfig: {
                type: Object,
                required: true
            }
        },
        data() {
          console.log(this.popupConfig)
            let note_temp = '';
            if(this.popupConfig.item_info.check_out) {
              note_temp = this.popupConfig.item_info.check_out.note;
            }
            return {
                StringHelper,
                 current: "",
                 number:'0',
                 note_temp,
                 promotion: '',
                 redemtion_list: [
                     { title: '3pts', value:'1', content: '$1 off for 3 points', checked: undefined },
                     { title: '100pts',value:'5', content: '$5 off for 100 points', checked: undefined },
                     { title: '300pts',value:'10', content: '$10 off for 300 points', checked: undefined },
                     { title: '500pts', value:'30', content: '500 points you can get free 30$', checked: undefined },
                 ],
                 promotion_list: [
                     { id: 1, value:'5', type:"percent", content: 'Remind after 30 days not visit', checked: undefined },
                     { id: 2, value:'10', type:"usd", content: 'Remind after 30 days not visit', checked: undefined },
                     { id: 3, value:'1', type:"percent", content: 'Remind after 30 days not visit', checked: undefined },
                     { id: 4, value:'5', type:"usd", content: 'Remind after 30 days not visit', checked: undefined }
                 ],
            }
        },
        methods: {
            changeFormat(day){
              if(day) {
                return moment(day).format('MM/DD/YYYY HH:MM');
              } else {
                return 'N/A';
              }
            },
            clearPromotion(){
              for(let i = 0;i<this.promotion_list.length;i++){
                // if(this.promotion_list[i].checked) {
                  this.promotion_list[i].checked = undefined;
                // }
              }
              document.getElementById('temp-radio').click();
            },
            clearRedemption() {
              for(let i = 0; i < this.redemtion_list.length; i++) {
                this.redemtion_list[i].checked = undefined;
              }
            },
            closePopup(){
              this.popupConfig.isOpen = false;
              this.current = "";
            },
            reCalculator(){
              let amountCurrent = parseFloat(this.current);
              let redemtion = 0;
              let promotion = 0;
              for(let i=0;i<this.redemtion_list.length;i++){
                if(this.redemtion_list[i].checked == true){
                  redemtion = redemtion + parseFloat(this.redemtion_list[i].value);
                }
              }
              for(let j=0;j<this.promotion_list.length;j++){
                if(this.promotion_list[j].checked == true){
                  if(this.promotion_list[j].type == "percent"){
                    promotion = (promotion + this.promotion_list[j].value/100)*amountCurrent;
                  }else{
                    promotion = promotion + parseFloat(this.promotion_list[j].value);
                  }
                }
              }
              if(amountCurrent <= (redemtion + promotion)){
                return 0;
              }else{
                return amountCurrent - redemtion - promotion;
              }
            },
            append(number) {
              if(this.current.length <= 8){
                if (this.operatorClicked) {
                  this.current = "";
                  this.operatorClicked = false;
                }
                if(this.current == '0' && number != '.') {
                  this.current = '';
                }
                this.current = `${this.current}${number}`;
              }
            },
            dot() {
              if(this.current == '') {
                this.append('0');
              }
              if (this.current.indexOf(".") === -1) {
                this.append(".");
              }
            },
            deleteNum(){
              return this.current = this.current.substring(0, this.current.length - 1);
            },
            changeStatusRadio(item) {
                for(let i = 0; i < this.promotion_list.length; i++) {
                    if(this.promotion_list[i].checked) {
                        this.promotion_list[i].checked = false;
                    }
                }
                for(let i = 0; i < this.promotion_list.length; i++) {
                    if(this.promotion_list[i].id == item.id) {
                        this.promotion_list[i].checked = true;
                    }
                }
            },
            getMemberTypeColor(member_type) {
                if (member_type == "new") return "success";
                if (member_type == "regular") return "primary";
                if (member_type == "vip") return "danger";
                return "dark";
            }
        },
        watch: {
          popupConfig: {
            immediate: true,
            deep: true,
            handler() {
              if(this.popupConfig.isOpen) {
                document.body.classList.add('overflow-hidden');
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
              } else {
                document.body.classList.remove('overflow-hidden');
                // this.clearRedemption();
                // this.clearPromotion();
              }
            }
          }
        },
        computed: {
          note: {
            get() {
              return this.note_temp;
            },
            set(value) {
              this.note_temp = value;
            }
          }
        }
    };
</script>
